import { useEffect, useState } from "react";
import { useTheme } from "../../../../components/hooks/useTheme";
import { useNavigate } from "react-router-dom";
import baseURL from "../../../../configs/api";
import CustomFormatDatePicker from "../../../../components/common/CustomFormatDatePicker";
import useGeneral from "../../../../components/hooks/useGeneral";
import axios from 'axios';
import { Button, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import PleaseWaitPopup from "../../../PleaseWaitPopup";
import Select from "react-select";
import colorConfigs from "../../../../configs/colorConfigs";
import useAuth from "../../../../components/hooks/useAuth";
import Cookies from "js-cookie";
import useTenant from "../../../../components/hooks/useTenant";

const accountingAccountOptions: any = [];
for (let i = 1; i <= 8; i++) {
  accountingAccountOptions.push({ value: i, label: i });
}

export const AddSeasons = () => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { auth }: any = useAuth();
  const { handleTenantError }: any = useTenant();
  const { dateFormat }: any = useGeneral();
  const { themeStyles } = useTheme();
  const navigate = useNavigate();
  const [name, setName] = useState<string>("");
  const [branchId, setBranchId] = useState<string>("");
  const [dateStart, setDateStart] = useState<string>("");
  const [dateEnd, setDateEnd] = useState<string>("");
  const [minimalRentalPeriodDays, setMinimalRentalPeriodDays] = useState<number>(0);
  const [maxRentalPeriodDays, setMaxRentalPeriodDays] = useState<number>(0);
  const [minimumRentlHours, setMinimumRentlHours] = useState<number>(0);
  const [maximumRentalHours, setMaximumRentalHours] = useState<number>(0);
  const [active, setActive] = useState<string>("Yes");
  const [accountingAccount, setAccountingAccount] = useState<string>("");
  const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);
  const [branches, setBranches] = useState([]);

  useEffect(() => {
    axios
      .get(`${baseURL}branch`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
      .then((response) => {
        setBranches(() =>
          response?.data?.map((item: any) => {
            return { value: item.id, label: item?.branchName };
          })
        );

        setBranchId(response?.data[0]?.id || "");
        handleTenantError(null);
      })
      .catch((error) => {
        setBranchId("");
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    setPleaseWaitPopup(true);
    e.preventDefault();

    await axios
      .post(
        `${baseURL}season?userId=${auth?.id}`,
        JSON.stringify({
          name,
          branchId,
          dateStart,
          dateEnd,
          minimalRentalPeriodDays,
          maxRentalPeriodDays,
          minimumRentlHours,
          maximumRentalHours,
          accountingAccount,
          isActive: active === "Yes",
        }),
        {
          headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
          },
          withCredentials: true,
        }
      )
      .then(() => {
        setPleaseWaitPopup(false);
        navigate(-1);
        handleTenantError(null);
      })
      .catch((error) => {
        setPleaseWaitPopup(false);
        handleTenantError(error);
      });
  };


  return (
    <>
      <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
        <div className={`w-full ${themeStyles.main.tailwindMainBg} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
          <div className="w-full mt-2">
            <div className={`w-full pb-4`}>

              <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                <div className="flex items-center gap-1.5">
                  <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Add Season</h2>
                </div>
              </div>

              <div className="mt-2 p-2">
                <form onSubmit={(e) => handleSubmit(e)}>
                  <div className="w-full px-2">
                    <div className="grid grid-cols-3 gap-6">

                      {/* First Column */}
                      <div className="space-y-4">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Branch</label>
                          <select
                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={branchId}
                            onChange={(e) => setBranchId(e.target.value)}
                          >
                            {branches?.map((role: any, index: number) => (
                              <option key={index} value={role.value}>
                                {role.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="space-y-4">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Name</label>
                          <input
                            type="text"
                            className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-3 gap-6">
                      <div className="space-y-4">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Date Start</label>
                          <CustomFormatDatePicker
                            value={dateStart}
                            onChange={setDateStart}
                            dateFormat={dateFormat}
                            required={true}
                          />
                        </div>
                      </div>

                      <div className="space-y-4">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Date End</label>
                          <CustomFormatDatePicker
                            value={dateEnd}
                            onChange={setDateEnd}
                            dateFormat={dateFormat}
                            required={true}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-3 gap-6">
                      <div className="space-y-4">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Minimal Rental Period (Days)</label>
                          <input
                            type="text"
                            inputMode="numeric"
                            name="minimalRentalPeriodDays"
                            className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={minimalRentalPeriodDays}
                            onChange={(e) => {
                              const value = e.target.value.replace(/\D/g, "");
                              setMinimalRentalPeriodDays(value === "" ? 0 : Number(value));
                            }}
                            onKeyDown={(e) => {
                              const allowedKeys = [
                                "Backspace",
                                "Delete",
                                "ArrowLeft",
                                "ArrowRight",
                                "Tab",
                                "Home",
                                "End",
                              ];

                              if (!allowedKeys.includes(e.key) && !/^\d$/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            onPaste={(e) => {
                              const pasted = e.clipboardData.getData("text");

                              if (!/^\d+$/.test(pasted)) {
                                e.preventDefault();
                              }
                            }}
                            onDrop={(e) => e.preventDefault()}
                            autoComplete="off"
                            required
                          />
                        </div>
                      </div>

                      <div className="space-y-4">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>
                            Max Rental Period (Days)
                          </label>

                          <input
                            type="text"
                            inputMode="numeric"
                            name="maxRentalPeriodDays"
                            className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={maxRentalPeriodDays}
                            onChange={(e) => {
                              const value = e.target.value.replace(/\D/g, "");
                              setMaxRentalPeriodDays(value === "" ? 0 : Number(value));
                            }}
                            onKeyDown={(e) => {
                              const allowedKeys = [
                                "Backspace",
                                "Delete",
                                "ArrowLeft",
                                "ArrowRight",
                                "Tab",
                                "Home",
                                "End",
                              ];

                              if (!allowedKeys.includes(e.key) && !/^\d$/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            onPaste={(e) => {
                              const pasted = e.clipboardData.getData("text");

                              if (!/^\d+$/.test(pasted)) {
                                e.preventDefault();
                              }
                            }}
                            onDrop={(e) => e.preventDefault()}
                            autoComplete="off"
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-3 gap-6">
                      <div className="space-y-4">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Minimum Rental Hours</label>
                          <input
                            type="text"
                            inputMode="numeric"
                            name="minimumRentlHours"
                            className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={minimumRentlHours}
                            onChange={(e) => {
                              const value = e.target.value.replace(/\D/g, "");
                              setMinimumRentlHours(value === "" ? 0 : Number(value));
                            }}
                            onKeyDown={(e) => {
                              const allowedKeys = [
                                "Backspace",
                                "Delete",
                                "ArrowLeft",
                                "ArrowRight",
                                "Tab",
                                "Home",
                                "End",
                              ];

                              if (!allowedKeys.includes(e.key) && !/^\d$/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            onPaste={(e) => {
                              const pasted = e.clipboardData.getData("text");

                              if (!/^\d+$/.test(pasted)) {
                                e.preventDefault();
                              }
                            }}
                            onDrop={(e) => e.preventDefault()}
                            autoComplete="off"
                            required
                          />
                        </div>
                      </div>

                      <div className="space-y-4">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Maximum Rental Hours</label>
                          <input
                            type="text"
                            inputMode="numeric"
                            name="maximumRentalHours"
                            className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={maximumRentalHours}
                            onChange={(e) => {
                              const value = e.target.value.replace(/\D/g, "");
                              setMaximumRentalHours(value === "" ? 0 : Number(value));
                            }}
                            onKeyDown={(e) => {
                              const allowedKeys = [
                                "Backspace",
                                "Delete",
                                "ArrowLeft",
                                "ArrowRight",
                                "Tab",
                                "Home",
                                "End",
                              ];

                              if (!allowedKeys.includes(e.key) && !/^\d$/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            onPaste={(e) => {
                              const pasted = e.clipboardData.getData("text");

                              if (!/^\d+$/.test(pasted)) {
                                e.preventDefault();
                              }
                            }}
                            onDrop={(e) => e.preventDefault()}
                            autoComplete="off"
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-3 gap-6">
                      <div className="space-y-4">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Accounting Account</label>
                          <Select
                            styles={{
                              control: (baseStyles, state) => ({
                                ...baseStyles,
                                backgroundColor: themeStyles.topBar.bg,
                                color: themeStyles.topBar.textColor,
                                borderRadius: '8px',
                                borderColor: state.isFocused ? "#167AC3" : themeStyles.topBar.borderColor,
                                "&: hover": {
                                  borderColor: "#167AC3",
                                }

                              }),
                              menu: (base) => ({
                                ...base,
                                fontSize: "12px",
                                backgroundColor: themeStyles.topBar.bg,
                                color: themeStyles.topBar.textColor,
                              }),
                              option: (base, state) => {
                                const isSelected = state.isSelected;
                                const isFocused = state.isFocused;
                                const selectedBg = themeStyles.topBar.menuItemsColor || "#167AC3";
                                const hoverBg = themeStyles.topBar.menuItemsHoverColor || "#E6F0FA";
                                const defaultTextColor = themeStyles.topBar.textColor || "#000";

                                return {
                                  ...base,
                                  backgroundColor: isSelected
                                    ? selectedBg
                                    : isFocused
                                      ? hoverBg
                                      : "transparent",
                                  color: isSelected ? "#fff" : defaultTextColor,
                                  fontWeight: 600,
                                  ':active': {
                                    backgroundColor: isSelected ? selectedBg : hoverBg,
                                  },
                                };
                              },
                              input: (base) => ({
                                ...base,
                                color: themeStyles.topBar.textColor,

                              }),
                              singleValue: (base) => ({
                                ...base,
                                color: themeStyles.topBar.textColor,
                              }),
                            }}
                            className="basic-single"
                            classNamePrefix="select"
                            isDisabled={false}
                            isLoading={false}
                            isClearable={true}
                            isRtl={false}
                            isSearchable={false}
                            name="accountingAccount"
                            value={accountingAccountOptions.find(
                              (item: any) => item.value === accountingAccount
                            )}
                            onChange={(accountingAccount: any) =>
                              setAccountingAccount(
                                accountingAccount ? accountingAccount.value : ""
                              )
                            }
                            options={accountingAccountOptions}
                          />
                        </div>
                      </div>

                      <div className="mt-4">
                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Active?</label>
                        <RadioGroup
                          row
                          value={active}
                          onChange={(e) => setActive(e.target.value)}
                        >
                          <FormControlLabel

                            value="Yes" control=
                            {<Radio
                              sx={{
                                color: "gray",
                                "&.Mui-checked": {
                                  color: "blue",
                                },
                              }}
                            />} label="Yes"
                            sx={{
                              color: themeStyles.form.labelTextColor
                            }}
                          />
                          <FormControlLabel value="No" control={
                            <Radio
                              sx={{
                                color: "gray",
                                "&.Mui-checked": {
                                  color: "blue",
                                },
                              }}
                            />} label="No"
                            sx={{
                              color: themeStyles.form.labelTextColor
                            }}
                          />
                        </RadioGroup>
                      </div>
                    </div>

                    {/* Buttons */}
                    <div className="flex gap-4 mt-6">
                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.main.bg
                        }}
                        type="submit">
                        Save
                      </Button>

                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.cancel.bg,
                          border: colorConfigs.btn.cancel.border,
                          color: colorConfigs.btn.cancel.color
                        }}
                        onClick={() => navigate(-1)}>
                        Cancel
                      </Button>
                    </div>

                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
    </>

  )
}